import { render, staticRenderFns } from "./sliding-widgets.vue?vue&type=template&id=489954a3&"
import script from "./sliding-widgets.vue?vue&type=script&lang=js&"
export * from "./sliding-widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports